export default __webpack_public_path__ + "static/media/dial.ba4107fa.png";